import React from 'react';
import { twMerge } from 'tailwind-merge';

export enum IconVariant {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xlarge',
}

interface IIconProps {
  icon: JSX.Element;
  variant: IconVariant;
}

const Icon = ({ icon, variant }: IIconProps) => {
  const smallClassName = twMerge('m-1', 'h-3', 'w-3', 'transition');
  const mediumClassName = twMerge('m-1.5', 'h-4', 'w-4', 'transition');
  const largeClassName = twMerge('m-4', 'h-10', 'w-10', 'transition');
  const xlargeClassName = twMerge('m-8', 'h-16', 'w-16', 'transition');

  const iconClassName = twMerge(
    'self-center',
    'text-kira-violet-900',
    `${variant === IconVariant.SMALL ? smallClassName : ''}`,
    `${variant === IconVariant.MEDIUM ? mediumClassName : ''}`,
    `${variant === IconVariant.LARGE ? largeClassName : ''}`,
    `${variant === IconVariant.XLARGE ? xlargeClassName : ''}`
  );

  return (
    <div className="flex justify-center self-center rounded-full bg-kira-slate-100">
      <div className={iconClassName}>{icon}</div>
    </div>
  );
};

export default Icon;
